// FIXME Winkelkreis bei AdvancedMode sichtbar, selbst wenn Höhe verändert wird
// FIXME wenn im AdvancedMode zwei Lums auf ähnlicher Höhe sind (innerhalb des Mindestabstands), dann sicherstellen, dass sie vom Winkel nicht zu eng stehen. entweder beim Drehen oder zumindest hinerher. beim drehen, würde erfordern, dass dies immer wenn die höhe aka position verändert wird, für alle lums getestet wird und für die einzelnen lums in einem neuen Array vermerkt wird
// WONT statt immer konstant 40° hinzuzurechnen, gucken ob für eine lum ein Wert gesetzt ist. Nein, ist nicht, da die Lums zum löschen ja immer hin und her geschoben werden, dazu müsste die komische Sortierung des Arras, wonach von unten gefüllt wird, aber immer an der obersten Stelle ein Lum sein muss, behoben werden


OLIVIO.Main = function (model, Data, $scope) {

  var self = this;

  var canvasside = document.getElementById('confcanvasside');
  var canvastop = document.getElementById('confcanvastop');


  //var infoCanvas = document.getElementById('confinfocanvas');
  var wrapper = document.getElementById('mainview');

  var nextbutton = document.getElementById('nextbtn');

  var VIEWBOX_FOUNDATION_ADDITION = 110;

  var poleTopSVGX = 0;
  var poleTopSVGY = 0;


  var langResLoaded = function (e, id) {
    //console.log(NeoUtils.langRes.next);
  };
  //NeoUtils.loadRes(navigator.language,langResLoaded);

  var drawside = SVG('confcanvasside');
  drawside.size('600', '600');

  var drawtop = SVG('confcanvastop');
  drawtop.size('600', '600');

  var infoDrawSide = SVG('confcanvasside').size('1000', '1000');
  infoDrawSide.size('100', '100');

  var infoDrawTop = SVG('confcanvastop').size('1000', '1000');
  infoDrawTop.size('100', '100');

  var deltaX = 0;
  var deltaY = 0;
  var lastX = 0;
  var lastY = 0;
  var boxSide;
  var pixelFactorSide;
  var boxTop;
  var pixelFactorTop;
  var currentSideId = -1;
  var currentTopId = -1;
  var currentClampId = -1;

  var curX = 0;
  var curY = 0;


  var editingLums = false;

  var viewBoxWidthSide = 4000;
  var viewBoxWidthTop = 4000;


  var rotationActive = false;


  this.setRotationActive = function (value) {
    deltaY = 0;
    deltaX = 0;
    rotationActive = value;
  };

  var getOffset = function (el) {
    var _x = 0;
    var _y = 0;
    while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
      _x += el.offsetLeft;
      _y += el.offsetTop;
      el = el.offsetParent;
    }
    return { top: _y, left: _x };
  };
  var updatePoleTopSVGPosition = function () {
    console.log('updatePoleTopSVGPosition');
    var offset = getOffset(canvastop);
    poleTopSVGX = offset.left;
    poleTopSVGY = offset.top;
  };

  //console.log(mmToWorldUnit+" "+(6000*mmToWorldUnit));

  drawside.viewbox(0, 0, viewBoxWidthSide, OLIVIO.cmodel.mastViewboxHeight+VIEWBOX_FOUNDATION_ADDITION);
  drawtop.viewbox(0, 0, viewBoxWidthTop, OLIVIO.cmodel.mastViewboxHeight);


  var backgroundside = drawside.rect(2000, 4000);
  backgroundside.fill({ color: '#f06', opacity: (OLIVIO.debug ? 0.1 : 0.0) });
  backgroundside.move(0, 0);

  var backgroundtop = drawtop.rect(2000, 4000);
  backgroundtop.fill({ color: '#f06', opacity: (OLIVIO.debug ? 0.1 : 0.0) });
  backgroundtop.move(0, 0);

  var poleTop, poleSide;

  function setPoleSelected(v) {
    //console.log('v--- setPoleSelected');
    OLIVIO.cmodel.poleSelected = v; // FIXME this really should not be stored in cmodel, but poletop and poleside only know cmodel, not it's parent main
    poleSide.repaint();
    poleTop.repaint();
    //console.log('^--- setPoleSelected');
  }

  this.editPole = function () {
    editingLums = false;
    OLIVIO.cmodel.setSingleLumSelected(-1);
    setPoleSelected(true);  // calls updateLums()
    clampline.setMode(OLIVIO.ClampLine.MODEPOLE);
    this.editinglums = false;
    $scope.setAdvancedEditingLumId(-1);
    if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
      $scope.$apply();
    }
  };

  this.editLums = function () {
    console.log('v- editLums');
    this.editNone();

    updatePoleTopSVGPosition();
    editingLums = true;


    OLIVIO.cmodel.setFirstAndLastLumSelected();
    setPoleSelected(false); // calls updateLums()

    clampline.setMode(OLIVIO.ClampLine.MODELUM);

    this.editinglums = true;

    $scope.setAdvancedEditingLumId(-1);
    if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
      $scope.$apply();
    }
    console.log('^- editLums');
  };

  this.setEditAdvanced = function (value) {
    console.log('setEditAdvanced '+OLIVIO.cmodel.isAdvancedMode()+' => '+value);
    if(value === OLIVIO.cmodel.isAdvancedMode())
      return;

    OLIVIO.cmodel.setAdvancedMode(value);
    if (OLIVIO.cmodel.isAdvancedMode()) {
      this.editNone();
      if (OLIVIO.cmodel.currentLumCount === 1) {
        editAdvancedLum(7);
      } else {
        editAdvancedLum(0);
      }
    } else {
      this.editNone();
      this.editLums();
      OLIVIO.cmodel.rearrangeLumsForBasicMode();
    }
  };


  this.editNone = function () {
    //console.log('editNone');
    editingLums = false;

    OLIVIO.cmodel.setSingleLumSelected(-1); // sets pub.firstAndLastLumSelected = false;
    setPoleSelected(false); // calls updateLums()


    clampline.setMode(OLIVIO.ClampLine.MODENONE);
    this.editinglums = false;
    $scope.setAdvancedEditingLumId(-1);
    if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
      $scope.$apply();
    }
  };

  var editAdvancedLum = function (lumId) {
    console.log('OlivioMain editAdvancedLum '+lumId);
    self.editNone();

    OLIVIO.cmodel.setSingleLumSelected(lumId);

    poleSide.updateLums();
    poleTop.updateLums();
    $scope.setAdvancedEditingLumId(lumId);
    if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
      $scope.$apply();
    }
  };

  this.setAdvancedSelection = function (lumId) {
    if (!OLIVIO.cmodel.isAdvancedMode()) {
      console.log('>>>>>>>>>>>> OlivioMain setAdvancedSelection: not in isAdvancedMode()');
      return;
    }
    console.log('OlivioMain setAdvancedSelection: '+lumId);
    OLIVIO.cmodel.setSingleLumSelected(lumId); // FIXME ruft lumChangeHandler auf, der wiederum updateLums aufruft
    //poleSide.updateLums();
    //poleTop.updateLums();
  };

  var backgroundClick = function () {
    if (OLIVIO.debug === true) {
      console.log('backgroundClick');
    }
    self.editNone();
  };

  backgroundside.on('click', backgroundClick);
  backgroundtop.on('click', backgroundClick);

  var clickPoleSide = function () {
    if (OLIVIO.cmodel.mastSizeChangeable === true) {
      self.editPole();
    }

  };

  var callbackSide = function (e, id) {
    if (OLIVIO.debug === true) {
      console.log('down on side' + id, e);
    }
    if (OLIVIO.cmodel.isAdvancedMode()) {
      OLIVIO.cmodel.updateLumBoundariesAdvanced();
      deltaY = 0;
      lastY = NeoUtils.getMouseY(e);
      currentSideId = id;
      editAdvancedLum(currentSideId);

    } else if (editingLums !== true) {
      self.editLums();
    }
  };

  poleSide = new OLIVIO.PoleSide(drawside, callbackSide, clickPoleSide);
  // pole ckickarea would occlude lums if nt made narrower
  //poleSide.pole.clickArea.scale(1, 1).move(poleSide.pole.gX + (poleSide.pole.gW - poleSide.pole.gW * 0.2) * 0.5, poleSide.pole.gY);

  var clickPoleTop = function () {
    if (OLIVIO.debug === true) {
      console.log('poleTop click');
    }
    if (OLIVIO.cmodel.mastSizeChangeable === true) {
      self.editPole();
    }
  };

  var callbackTop = function (e, id) {
    if (OLIVIO.debug === true) {
      console.log('down on top' + id);
    }
    updatePoleTopSVGPosition();
    if (OLIVIO.cmodel.isAdvancedMode()) {
      OLIVIO.cmodel.updateLumBoundariesAdvanced();
      updatePoleTopSVGPosition();
      currentTopId = id;
      editAdvancedLum(currentTopId);

    } else if (editingLums === true) {
      OLIVIO.cmodel.startArrangingLumPositions();
      if (id === 0 || id === 7) {
        currentTopId = id;
      }
    } else {

      self.editLums();

    }


  };

  poleTop = new OLIVIO.PoleTop(drawtop, callbackTop, clickPoleTop);


  var callbackClampDown = function (e, areaId) {
    if (OLIVIO.debug === true) {
      console.log('down on clampArea: ' + areaId);
    }

    deltaY = 0;
    lastY = NeoUtils.getMouseY(e);
    currentClampId = areaId;

    // TODO (Herbert) clampDownTime merken und falls bei einem mouseMove in den ersten 100ms lumsOnOneLevel ===true && currentClampId === AREABOTTOM && Bewegung nach oben, dann currentClampId auf AREATOP umstellen
  };

  var clampline = new OLIVIO.ClampLine(drawside, callbackClampDown);


  var lumsChangedHandler = function () {
    console.log('v OlivioMain lumsChangedHandler');
    poleSide.updateLums(); // FIXME passiert oft schon bevor lumChangeHandler aufgerufen wird -- aber notwendig beim Wechsel der Orientierung der Lums
    console.log('+ OlivioMain lumsChangedHandler A');
    poleSide.updatePoleRotation(false);
    console.log('+ OlivioMain lumsChangedHandler B');
    poleTop.updateLums(); // FIXME passiert oft schon bevor lumChangeHandler aufgerufen wird -- aber notwendig beim Wechsel der Orientierung der Lums
    console.log('+ OlivioMain lumsChangedHandler C');
    clampline.updateClamp();
    console.log('^ OlivioMain lumsChangedHandler');
  };

  var mastChangedHandler = function () {
    console.log('vvv- OlivioMain mastChangedHandler '+OLIVIO.cmodel.mastSelected);
    poleSide.updateHeight();
    poleSide.repaint();
    poleTop.repaint();
    if(clampline.mode === OLIVIO.ClampLine.MODEPOLE && !OLIVIO.cmodel.poleSelected)
      clampline.setMode(OLIVIO.ClampLine.MODENONE);
    if (currentClampId === -1) {
      clampline.updateClamp();
    }
    console.log('^^^- OlivioMain mastChangedHandler '+OLIVIO.cmodel.mastSelected);
  };

  OLIVIO.cmodel.mastHeightWorldMax = poleSide.worldHeight();
  OLIVIO.cmodel.setCallbacks(lumsChangedHandler, mastChangedHandler);
  //callbackClampMastSize(OLIVIO.cmodel.mastHeightWorldMax,OLIVIO.cmodel.mastSizesmm[OLIVIO.cmodel.mastSizeIndex]*OLIVIO.cmodel.mmToWorldUnit);

  clampline.initClamp();
  clampline.setMode(OLIVIO.ClampLine.MODENONE);


  var resizeHandler = function () {
    console.log('resizeHandler');
    updatePoleTopSVGPosition();

    drawside.size(canvasside.offsetWidth, canvasside.offsetHeight);
    viewBoxWidthSide = OLIVIO.cmodel.mastViewboxHeight * ((canvasside.offsetWidth) / canvasside.offsetHeight);
    drawside.viewbox(0, 0, viewBoxWidthSide, OLIVIO.cmodel.mastViewboxHeight+VIEWBOX_FOUNDATION_ADDITION);

    drawtop.size(canvastop.offsetWidth, canvastop.offsetHeight);
    viewBoxWidthTop = 1500 * ((canvastop.offsetWidth) / canvastop.offsetHeight);
    drawtop.viewbox(0, 0, 1500, 1500);


    backgroundside.size(viewBoxWidthSide, OLIVIO.cmodel.mastViewboxHeight);
    backgroundtop.size(1500, 1500);

    boxSide = drawside.viewbox();
    pixelFactorSide = 1/boxSide.zoom;
    boxTop = drawtop.viewbox();
    pixelFactorTop = 1/boxTop.zoom;


    // var rightColumnPix = (((poleTopX-300)*pixelFactor)+canvasOffsetX)+'px';
    // rotationTitle.style.left = rightColumnPix;

  };

  this.getPixelFactorSide = function () {
    return pixelFactorSide;
  };

  this.updateViewBoxes = function () {
    console.log('updateViewBoxes');
    resizeHandler();
    pixelFactorSide = 1/boxSide.zoom;
    pixelFactorTop = 1/boxTop.zoom;
  };

  var infoObjects = {};

  resizeHandler();

  NeoUtils.addEventHandler(window, 'resize', resizeHandler);

  /*
   savebutton.onclick = function() {
   svgString = draw.exportSvg();
   a = document.createElement('a');
   a.download = 'olivio.svg';
   a.type = 'image/svg+xml';
   blob = new Blob([svgString], {"type": "image/svg+xml"});
   a.href = (window.URL || webkitURL).createObjectURL(blob);
   a.click();
   return false;
   }*/

  this.savePoleTop = function() {
    var svgString = drawtop.exportSvg();
    var a = document.createElement('a');
    a.download = 'olivio.svg';
    a.type = 'image/svg+xml';
    var blob = new Blob([svgString], {'type': 'image/svg+xml'});
    a.href = window.URL.createObjectURL(blob);
    //a.href = (window.URL || webkitURL).createObjectURL(blob);
    a.click();
  };


  function mouseMove(e) {
    //e.preventDefault();

    curX = NeoUtils.getMouseX(e);
    curY = NeoUtils.getMouseY(e);
    //console.log(curX+" "+curY);
    //console.log(e.target.id);

    if (currentSideId > -1) {
      e.stopImmediatePropagation();
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
      boxSide = drawside.viewbox();
      pixelFactorSide = 1 / boxSide.zoom;
      deltaY = (curY - lastY) * pixelFactorSide;
      lastY = curY;
      //console.log(sidelums[currentSideId].group.trans.y+" "+curY);
      OLIVIO.cmodel.setLumWorldPosition(currentSideId, deltaY);
      //poleSide.moveLumYBy(currentSideId, deltaY);
      //sidelums[currentSideId].group.move(0,sidelums[currentSideId].group.trans.y + deltaY);
    } else if (currentTopId > -1) {
      e.stopImmediatePropagation();
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
      boxTop = drawtop.viewbox();
      //pixelFactor = 1/box.zoom;
      var radians = Math.atan2(curX - 750 * boxTop.zoom - poleTopSVGX, curY - 750 * boxTop.zoom - poleTopSVGY);
      var degrees = (450 - (radians * (180 / Math.PI)) );
      if (degrees >= 360) {
        degrees -= 360;
      }
      //console.log(degrees);
      if (OLIVIO.cmodel.isAdvancedMode()) {
        OLIVIO.cmodel.setLumRotationCombined(currentTopId,degrees);
      } else {
        if (currentTopId === 0) {
          OLIVIO.cmodel.setStartRotation(degrees, true);
        } else if (currentTopId === 7) {
          if (OLIVIO.cmodel.getStartLumCount() === 1) {
            OLIVIO.cmodel.setStartRotation(degrees, true);
          } else {
            OLIVIO.cmodel.setEndRotation(degrees);
          }
        }
      }
      //poleTop.rotateByRadians(currentTopId,radians);
      //console.log(curX+","+curY+"  ----  "+(poleTop.centerX()*box.zoom-canvasOffsetY));
    } else if (currentClampId > -1) {
      e.stopImmediatePropagation();
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
      boxSide = drawside.viewbox();
      pixelFactorSide = 1 / boxSide.zoom;
      deltaY = (curY - lastY) * pixelFactorSide;
      lastY = curY;
      //console.log(sidelums[currentSideId].group.trans.y+" "+curY);
      clampline.moveBy(currentClampId, deltaY);
    } else if (rotationActive === true) {
      e.stopImmediatePropagation();
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
      //if (Math.abs(curX - lastX) >= 5) {
      deltaX = (curX - lastX);
      lastX = curX;
      if (OLIVIO.cmodel.product === OLIVIO.PRODUCT_CANDELABRA) {
        OLIVIO.cmodel.setCandelabraRotation(OLIVIO.cmodel.candelabraRotation - deltaX);
      } else {
        if (OLIVIO.cmodel.isAdvancedMode()) {
          OLIVIO.cmodel.setLumRotationsCombined(-deltaX);
        } else {
          OLIVIO.cmodel.setStartRotation(OLIVIO.cmodel.startRotation - deltaX, false);
        }

      }
      //

      //} else {
      //    curX = lastX;
      //}

    }
  }

  function mouseUp() {
    //console.log('mouseup');
    currentSideId = -1;
    currentTopId = -1;
    currentClampId = -1;
    rotationActive = false;
  }


  function mouseDown(e) {
    //console.log(e.target.tagName);
    lastX = NeoUtils.getMouseX(e);
    lastY = NeoUtils.getMouseY(e);
    curX = NeoUtils.getMouseX(e);
    curY = NeoUtils.getMouseY(e);
    deltaY = 0;
    deltaX = 0;
    //console.log('DOWN: '+lastX+' '+lastY);
    if (e.target.tagName.toLowerCase() === 'div') {
      //console.log('MOUSE DOWN!!!! : '+ e.target);
      self.editNone();
    }
  }

  NeoUtils.addDownHandler(document,mouseDown);
  NeoUtils.addMoveHandler(document,mouseMove);
  NeoUtils.addUpHandler(document,mouseUp);

  // TODO probably needs to be more thorough
  this.destroy = function () {

    OLIVIO.cmodel.removeCallbacks();

    NeoUtils.removeEventHandler(window, 'resize', resizeHandler);

    NeoUtils.removeDownMoveUpHandlers(document,mouseDown);
    NeoUtils.removeDownMoveUpHandlers(document,mouseMove);
    NeoUtils.removeDownMoveUpHandlers(document,mouseUp);


    wrapper = null;
    canvasside = null;
    canvastop = null;
    infoDrawSide = null;
    infoDrawTop = null;

    clampline.unBindHandlers();
    poleSide.unBindHandlers();
    poleTop.unBindHandlers();

    clampline = null;
    poleSide = null;
    poleTop = null;

    nextbutton = null;
    drawside = null;
    drawtop = null;
    infoObjects = null;
  };


  OLIVIO.cmodel.initFromAngularModel(model, Data);
  poleSide.updateLumsForceRotation();
};

// TODO remove this, seems to be debug code
//OLIVIO.MainCheckStuff = function (Model, $scope) {
//  var m = new OLIVIO.Main(Model, $scope);
//  this.destroy = function () {
//    m.destroy();
//    m = null;
//  };
//  this.updateViewBoxes = function () {
//    m.updateViewBoxes();
//  };
//
//
//  var secs = 0;
//  setInterval(function () {
//    console.log('i lived for: ' + secs + ' seconds and i am: ' + m);
//    secs++;
//  }, 1000);
//};
